import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NewInspectionReportComponent } from "./new-inspection-report.component";
const routes: Routes = [
  {
    path: "",
    component: NewInspectionReportComponent,
  },
  {
    path: "view-new-report/:id",
    component: NewInspectionReportComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InspectionReportRoutingModule {}
